module.exports = __webpack_public_path__ + "img/C.039ac424.png";